export const sectionLabelSx = {
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: "0.07em",
  textTransform: "uppercase" as const,
  color: "#797979",
  mb: "7px"
} as const;

export const sectionTitleSx = {
  fontSize: "20px",
  fontWeight: 700,
  lineHeight: "28px",
  color: "#071F35"
} as const;

export const sectionSubtitleSx = {
  fontSize: "15px",
  fontWeight: 400,
  lineHeight: "20px",
  color: "#496682"
} as const;

export const fieldLabelSx = {
  display: "block" as const,
  fontSize: 12,
  fontWeight: 500,
  color: "#5d7782",
  mb: "4px"
};

export const fieldInputSx = {
  "& .MuiOutlinedInput-root": {
    height: 36,
    borderRadius: "6px",
    fontSize: 13,
    bgcolor: "#fff",
    "& fieldset": { borderColor: "#7b92a9" },
    "&:hover fieldset": { borderColor: "#7b92a9" },
    "&.Mui-focused fieldset": { borderWidth: 1, borderColor: "#071f35" }
  },
  "& .MuiOutlinedInput-input": { py: 0, px: "10px", fontSize: 13, lineHeight: 1.43 }
};

export const floatingTextFieldSx = {
  "& .MuiOutlinedInput-root": {
    padding: "0px",
    borderRadius: "8px",
    bgcolor: "#fff",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#071F35",
    "& fieldset": { borderColor: "#7B92A9" },
    "&:hover fieldset": { borderColor: "#7B92A9" },
    "&.Mui-focused fieldset": { borderWidth: 1, borderColor: "#071F35" }
  },
  "& .MuiOutlinedInput-input": {
    py: "8px",
    px: "8px",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#071F35",
    "&::placeholder": { color: "#92A7BC", opacity: 1 }
  },
  "& .MuiInputLabel-root": {
    fontSize: "14px",
    color: "#496682",
    "&.Mui-focused": { color: "#496682" }
  },
  "& .MuiInputLabel-shrink": {
    fontSize: "16px",
    fontWeight: 500,
    color: "#496682"
  }
} as const;

export const btnSx = {
  height: 30,
  borderRadius: "100px",
  border: `1px solid ${"#dbe8f5"}`,
  bgcolor: "#fff",
  color: "#071f35",
  px: "13px",
  fontSize: 12,
  fontWeight: 500,
  textTransform: "none" as const,
  boxShadow: "none",
  "&:hover": { bgcolor: "#f6f8fc", borderColor: "#dbe8f5", boxShadow: "none" }
};

export const btnPrimarySx = {
  ...btnSx,
  bgcolor: "#071f35",
  borderColor: "#071f35",
  color: "#fff",
  "&:hover": { bgcolor: "#0a3142", borderColor: "#0a3142", boxShadow: "none" }
};

export const btnGhostSx = {
  ...btnSx,
  border: "1px solid transparent",
  bgcolor: "transparent",
  color: "#5d7782",
  "&:hover": { bgcolor: "#f6f8fc", color: "#071f35", borderColor: "transparent", boxShadow: "none" }
};

export const pillOutlinedBtnSx = {
  borderRadius: "32px",
  border: "1px solid #071F35",
  bgcolor: "#fff",
  color: "#071F35",
  px: "16px",
  py: "4px",
  minHeight: 0,
  minWidth: 0,
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 400,
  textTransform: "none" as const,
  boxShadow: "none",
  "&:hover": { bgcolor: "#F6F8FC", borderColor: "#071F35", boxShadow: "none" }
} as const;

export const iconPillBtnSx = {
  width: 32,
  height: 32,
  p: "6px",
  borderRadius: "32px",
  bgcolor: "#F6F8FC",
  color: "#071F35",
  "&:hover": { bgcolor: "#E8EEF7" },
  "&.Mui-disabled": { opacity: 0.4, bgcolor: "#F6F8FC" }
} as const;

export const ibtnSx = {
  width: 30,
  height: 30,
  borderRadius: "8px",
  border: `1px solid ${"#dbe8f5"}`,
  bgcolor: "#fff",
  color: "#5d7782",
  "&:hover": { bgcolor: "#f6f8fc" },
  "&.Mui-disabled": { opacity: 0.4, bgcolor: "#fff" }
};
